var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPickup(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.194,
    height: 16.97,
    viewBox: "0 0 18.194 16.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_08_Delivery",
    "data-name": "08 Delivery",
    transform: "translate(-18.354 -23.806)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pickup",
    transform: "translate(-3.82 -21.344)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7121",
    "data-name": "Path 7121",
    d: "M100,55.251V46.974a1.174,1.174,0,0,1,1.174-1.174h9.686a1.174,1.174,0,0,1,1.174,1.174v9.354",
    transform: "translate(-74.803)",
    fill: "none",
    stroke: "#db5f00",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7122",
    "data-name": "Path 7122",
    d: "M184,45.8a2.889,2.889,0,0,0,5.779,0Z",
    transform: "translate(-155.671 0)",
    fill: "none",
    stroke: "#db5f00",
    strokeWidth: 1.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7123",
    "data-name": "Path 7123",
    d: "M22.3,210.892s2.669.544,3.471-.261,5.443-3.039,5.443-3.039a1.085,1.085,0,0,1,1.5,1.171c0,1.67-4.094,3.113-4.094,3.113s-1.376.541-.675,1.245,4.768.209,4.768.209l5.548-1.607s1.45-.693,1.45.828-5.909,3.628-5.909,3.628a51.93,51.93,0,0,1-6.532.984c-1.562,0-2.643-1.45-3.318-1.45s-1.659-.1-1.659-.1",
    transform: "translate(0 -155.693)",
    fill: "none",
    stroke: "#db5f00",
    strokeWidth: 1.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPickup);
export default __webpack_public_path__ + "static/media/Pickup.06d1a919e2ce21bd5638cfc5191769a7.svg";
export { ForwardRef as ReactComponent };